
import { IGetClientesDropDownUseCase } from "../../../presentation/useCases/read/get_clientes_dropdown_use_case";
import { ClienteDropDown } from "../../models/cliente_dropdown";
import { ICommonsRepository } from "../../repositories/commons_repository";

/**
 * GetClientesDropDownUseCase
 */

export class GetClientesDropDownUseCase implements IGetClientesDropDownUseCase {
  constructor(
    private readonly repository: ICommonsRepository,
  ) { }

  async getClientesDropDown(idCentroCusto?: number | null): Promise<ClienteDropDown[]> {
    return this.repository.getClientesDropDown(idCentroCusto);
  }
}